import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { PagedResponse } from '../../../../shared/contract/paged-response.contract';
import { getHttpParameters } from '../../../../shared/utils/get-http-parameters';
import { AcknowledgeAutomatedTransferNotificationCommand } from '../../contract/acknowledge-automated-transfer-notificaton-command.contract';
import { AutomatedTransferNotification } from '../../contract/automated-transfer-notification.contract';
import { AutomatedTransferNotificationsCount } from '../../contract/automated-transfer-notifications-count.contract';
import { AutomatedTransfersAlarmNotificationsParams } from '../contract/automated-transfers-alarm-notifications-params.contract';

@Injectable({ providedIn: 'root' })
export class AutomatedTransfersNotificationsApiService {
  private http = inject(HttpClient);

  private readonly url = environment.APP_DISPOSITION_SERVICE_BASE_URL;
  private readonly automatedTransfersUrl = `${this.url}/api/v1/automated-transfers`;

  public getCurrentActive(
    request: AutomatedTransfersAlarmNotificationsParams,
  ): Observable<PagedResponse<AutomatedTransferNotification>> {
    const httpParams = getHttpParameters(request);
    return of();
    return this.http.get<PagedResponse<AutomatedTransferNotification>>(
      `${this.automatedTransfersUrl}/notifications/alarms/current-active`,
      { params: httpParams },
    );
  }

  public getCurrentActiveCount(): Observable<AutomatedTransferNotificationsCount> {
    return this.http.get<AutomatedTransferNotificationsCount>(`${this.automatedTransfersUrl}/count`);
  }

  public acknowledgeAutomatedTransferNotification(
    command: AcknowledgeAutomatedTransferNotificationCommand,
  ): Observable<string> {
    return this.http.put(
      `${this.automatedTransfersUrl}/notifications/alarms/${command.id}/acknowledge`,
      JSON.stringify(command),
      {
        responseType: 'text',
      },
    );
  }

  // TODO: not refined yet https://onestop-pro.atlassian.net/browse/BEUT-30480
  public acknowledgeAllAutomatedTransferNotifications(): Observable<string> {
    const body = { read: true };

    return this.http.put<string>(
      `${this.automatedTransfersUrl}/notifications/alarms/acknowledge/all`,
      JSON.stringify(body),
    );
  }
}
